import { PageHeader } from "../components/admin/PageHeader";
import { SettingsPanel } from "../components/admin/SettingsPanel";

export function SettingsPage({ group }: { group: string }) {
  return (
    <div className="wr-page wr-settings-page">
      <PageHeader
        eyebrow="Configuration"
        title={group}
        description="Configure defaults with clear validation, preview, and save feedback."
        meta={
          <>
            <span>Saved per store</span>
            <span>Webhook-safe defaults</span>
            <span>No billing gates</span>
          </>
        }
      />
      <SettingsPanel group={group} />
    </div>
  );
}
